module.exports = __webpack_public_path__ + "img/cookies.6c8cebcc.png";